<section
  class="landing-a__section landing-a__onboarding-section"
  id="get-started"
  appLandingReveal="landing-a__onboarding-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__onboarding-grid">
      <div class="landing-a__onboarding-copy">
        <span class="landing-a__section-kicker">
          {{ 'landing.landing_1.onboarding.kicker' | translate }}
        </span>
        <h2 class="landing-a__onboarding-title">
          {{ 'landing.landing_1.onboarding.title' | translate }}
        </h2>
        <p class="landing-a__onboarding-subtitle">
          {{ 'landing.landing_1.onboarding.subtitle' | translate }}
        </p>

        <ul class="landing-a__onboarding-highlights">
          @for (highlight of highlights; track highlight) {
            <li class="landing-a__onboarding-highlight">
              <i-tabler name="check" aria-hidden="true"></i-tabler>
              <span>{{ 'landing.landing_1.onboarding.highlights.' + highlight | translate }}</span>
            </li>
          }
        </ul>

        <div class="landing-a__onboarding-actions">
          <a
            class="landing-a__btn landing-a__btn--primary"
            href="#pricing"
            (click)="scrollToSection('pricing', $event)"
          >
            {{ 'landing.landing_1.onboarding.cta' | translate }}
          </a>
          <p class="landing-a__onboarding-note">
            {{ 'landing.landing_1.onboarding.note' | translate }}
          </p>
        </div>
      </div>

      <ol class="landing-a__onboarding-timeline">
        @for (step of steps; track step.key; let index = $index; let last = $last) {
          <li class="landing-a__onboarding-step" [class.landing-a__onboarding-step--last]="last">
            <div class="landing-a__onboarding-step-track" aria-hidden="true">
              <span
                class="landing-a__onboarding-step-line landing-a__onboarding-step-line--before"
                [class.landing-a__onboarding-step-line--spacer]="index === 0"
              ></span>
              <span class="landing-a__onboarding-step-marker">
                <i-tabler [name]="step.icon"></i-tabler>
              </span>
              <span
                class="landing-a__onboarding-step-line landing-a__onboarding-step-line--after"
                [class.landing-a__onboarding-step-line--spacer]="last"
              ></span>
            </div>
            <div class="landing-a__onboarding-step-body">
              <span class="landing-a__onboarding-step-index">
                {{ 'landing.landing_1.onboarding.step_label' | translate: { step: index + 1 } }}
              </span>
              <h3>{{ 'landing.landing_1.onboarding.steps.' + step.key + '.title' | translate }}</h3>
              <p>{{ 'landing.landing_1.onboarding.steps.' + step.key + '.description' | translate }}</p>
            </div>
          </li>
        }
      </ol>
    </div>
  </div>
</section>
